export const calculateBreakRecordTotalReductions = (
  breakRecordData,
  mealBreakRecordData,
  coffeeBreakRecordData,
  paidCoffeeBreakHours
) => {
  let totalReductions = 0;

  if (breakRecordData) {
    totalReductions += breakRecordData.value;
  }

  if (mealBreakRecordData) {
    totalReductions += mealBreakRecordData.value;
  }

  if (
    coffeeBreakRecordData &&
    coffeeBreakRecordData.value > paidCoffeeBreakHours
  ) {
    const coffeeBreakLengthValueWithPaidPortionReduced =
      coffeeBreakRecordData.value - paidCoffeeBreakHours;

    totalReductions += coffeeBreakLengthValueWithPaidPortionReduced;
  }
  return totalReductions;
};
